import { Action } from '@ngrx/store';
import { isNotNil } from '@util/type';
import * as R from 'ramda';

export const hasCorrelationId = (action: Action) => isNotNil(getCorrelationId(action));

export const getCorrelationId = (action: Action): number => R.prop('cid', action);

export const getNextCorrelationId = () => Date.now();

export const createActionWithCorrelationId = (action: Action, cid: number) => ({
  ...action, cid
});

export const addCorrelationId = (actions) => {
  const cid = getNextCorrelationId();
  return R.map((action: Action) => createActionWithCorrelationId(action, cid), actions);
};
